import React, { useState, useEffect } from 'react';
import { addExploreData } from './services/addExploreData';
import { updateExploreData } from './services/exploreDataService';

const AddOrEditExploreDataForm = ({ initialData = null, onSuccess, onError, onClose }) => {
  const [formData, setFormData] = useState({
    id: '',
    videoLink: '',
    backgroundImage: '',
    description: '',
    text: '',
    type: '',
    status: '',
    section: '',
  });

  const [isEdit, setIsEdit] = useState(false); // Track if we are in edit mode

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
      setIsEdit(true);
    }
  }, [initialData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEdit) {
        await updateExploreData({ id: formData.id, status: formData.status });
      } else {
        await addExploreData(formData);
      }
      onSuccess();
      onClose();
    } catch (error) {
      onError();
    }
  };

  return (
    <form
      className="row g-3"
      onSubmit={handleFormSubmit}
      style={{ marginTop: '20px', marginBottom: '30px' }}
    >
      {/* Video Link */}
      <div className="row align-items-center mb-3 fw-bold">
        <label htmlFor="videoLink" className="col-sm-3 col-form-label">
          Video Link
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            id="videoLink"
            name="videoLink"
            value={formData.videoLink}
            onChange={handleInputChange}
            className="form-control"
            disabled={isEdit}
          />
        </div>
      </div>

      {/* Background Image */}
      <div className="row align-items-center mb-3 fw-bold">
        <label htmlFor="backgroundImage" className="col-sm-3 col-form-label">
          Background Image
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            id="backgroundImage"
            name="backgroundImage"
            value={formData.backgroundImage}
            onChange={handleInputChange}
            className="form-control"
            disabled={isEdit}
          />
        </div>
      </div>

      {/* Description */}
      <div className="row align-items-center mb-3 fw-bold">
        <label htmlFor="description" className="col-sm-3 col-form-label">
          Description
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            id="description"
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            className="form-control"
            disabled={isEdit}
          />
        </div>
      </div>

      {/* Text */}
      <div className="row align-items-center mb-3 fw-bold">
        <label htmlFor="text" className="col-sm-3 col-form-label">
          Text
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            id="text"
            name="text"
            value={formData.text}
            onChange={handleInputChange}
            className="form-control"
            disabled={isEdit}
          />
        </div>
      </div>

      {/* Type */}
      <div className="row align-items-center mb-3 fw-bold">
        <label htmlFor="type" className="col-sm-3 col-form-label">
          Type
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            id="type"
            name="type"
            value={formData.type}
            onChange={handleInputChange}
            className="form-control"
            disabled={isEdit}
          />
        </div>
      </div>

      {/* Status */}
      <div className="row align-items-center mb-3 fw-bold">
        <label htmlFor="status" className="col-sm-3 col-form-label">
          Status
        </label>
        <div className="col-sm-9">
          <select
            id="status"
            name="status"
            value={formData.status}
            onChange={handleInputChange}
            className="form-select"
            required
          >
            <option value="">Select Status</option>
            <option value="0">Inactive</option>
            <option value="1">Active</option>
          </select>
        </div>
      </div>

      {/* Section */}
      <div className="row align-items-center mb-3 fw-bold">
        <label htmlFor="section" className="col-sm-3 col-form-label">
          Section
        </label>
        <div className="col-sm-9">
          <select
            id="section"
            name="section"
            value={formData.section}
            onChange={handleInputChange}
            className="form-select"
            disabled={isEdit}
          >
            <option value="">Select Section</option>
            <option value="learn">Learn</option>
            <option value="feature">Feature</option>
            <option value="offer">Offer</option>
            <option value="service">Service</option>
          </select>
        </div>
      </div>

      {/* Submit Button */}
      <div className="text-end">
        <button type="submit" className="btn btn-primary">
          {isEdit ? 'Update Status' : 'Add Explore Data'}
        </button>
      </div>
    </form>
  );
};

export default AddOrEditExploreDataForm;
